import resume from '../assets/pdf/CV_Esperance_AHOUISSOU_fullstack.pdf'

export const headerData = {
    name: 'Espérance AHOUISSOU',
    title: "Web Developer & UI/UX Designer",
    desciption:"Je transforme les idées en expériences numériques. Chaque projet est pour moi l’occasion de combiner design, ergonomie et développement technique.",
    image: 'hero_img.png',
    resumePdf: resume
}
